import React from 'react';
import PropTypes from 'prop-types';

import ChipInput from 'material-ui-chip-input';
import FieldTitle from 'components/aor/FieldTitle';
import styled, { css } from 'styled-components';
import translate from 'components/hoc/translate';
const dataSourceConfig = { text: 'text', value: 'value' };

class SelectArrayInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: this.getChoicesForValues(props.input.value || [], props.choices),
        };
    }

    componentDidUpdate = (prevProps) => {
        const { choices, input } = this.props;

        if (
            choices !== prevProps.choices ||
            input.value !== prevProps.input.value
        ) {
            this.setState({
                values: this.getChoicesForValues(input.value || [], choices),
            });
        }
    };

    handleBlur = () => {
        const extracted = this.extractIds(this.state.values);

        this.props.onBlur(extracted);
        this.props.input.onBlur(extracted);
    };

    handleFocus = () => {
        const extracted = this.extractIds(this.state.values);

        this.props.onFocus(extracted);
        this.props.input.onFocus(extracted);
    };

    handleAdd = (newValue) => {
        const values = [
            ...this.state.values,
            newValue,
        ];

        this.setState({ values });
        this.handleChange(values);
    };

    handleDelete = (newValue) => {
        const values = this.state.values.filter((v) => {
            return v.value !== newValue;
        });

        this.setState({ values });
        this.handleChange(values);
    };

    handleChange = (eventOrValue) => {
        const extracted = this.extractIds(eventOrValue);

        this.props.onChange(extracted);
        this.props.input.onChange(extracted);
    };

    extractIds = (eventOrValue) => {
        const value = (eventOrValue.target && eventOrValue.target.value) ? eventOrValue.target.value : eventOrValue;

        if (Array.isArray(value)) {
            return value.map((o) => {
                return o.value;
            });
        }

        return [
            value,
        ];
    };

    getChoicesForValues = (values, choices = []) => {
        const { optionValue, optionText } = this.props;

        if (!values || !Array.isArray(values)) {
            throw Error('Value of SelectArrayInput should be an array');
        }

        return values
            .map((value) => {
                return choices.find((c) => {
                    return c[optionValue] === value;
                }) || { [optionValue]: value, [optionText]: value };
            })
            .map(this.formatChoice);
    };

    formatChoices = (choices) => {
        return choices.map(this.formatChoice);
    };

    formatChoice = (choice) => {
        const { optionText, optionValue, translateChoice, translate } = this.props;
        const choiceText = typeof optionText === 'function' ? optionText(choice) : choice[optionText];

        return {
            value: choice[optionValue],
            text: translateChoice ? translate(choiceText, { _: choiceText }) : choiceText,
        };
    }

    render() {
        const {
            className,
            elStyle,
            input,
            choices,
            label,
            meta: {
                touched,
                error,
            },
            fullWidth,
            options,
            resource,
            source,
            setFilter,
        } = this.props;

        return (
            <ChipInput
                { ...input }
                className={ className }
                value={ this.state.values }
                onBlur={ this.handleBlur }
                onFocus={ this.handleFocus }
                onTouchTap={ this.handleFocus }
                onRequestAdd={ this.handleAdd }
                onRequestDelete={ this.handleDelete }
                onUpdateInput={ setFilter }
                floatingLabelText={
                    label ? <FieldTitle label={ label } source={ source } resource={ resource } /> : false
                }
                errorText={ touched && error }
                style={ elStyle }
                dataSource={ this.formatChoices(choices) }
                dataSourceConfig={ dataSourceConfig }
                openOnFocus
                fullWidth={ fullWidth }
                { ...options }
            />
        );
    }
}

SelectArrayInput.defaultProps = {
    choices: [],
    onBlur: () => {
        return true;
    },
    onChange: () => {
        return true;
    },
    onFocus: () => {
        return true;
    },
    options: {},
    optionText: 'name',
    optionValue: 'id',
    translateChoice: true,
};

SelectArrayInput.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
    elStyle: PropTypes.object,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    optionText: PropTypes.string.isRequired,
    optionValue: PropTypes.string.isRequired,
    options: PropTypes.object,
    resource: PropTypes.string,
    setFilter: PropTypes.func,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
    translateChoice: PropTypes.bool.isRequired,
};

const labelEmptyStyles = css((props) => {
    return props.label
        ? 'margin-top: 12px !important;'
        : '';
});

const valueEmptyStyles = css((props) => {
    return props.input.value.length
        ? ''
        : `> div:nth-child(1) {
            transform: translateY(-6px);
        }

        > div:nth-child(2) {
            margin-bottom: 20px !important;
            height: 28px !important;
        }
    `;
});

const StyledSelectArrayInput = styled(SelectArrayInput)`
    ${ labelEmptyStyles }

    ${ valueEmptyStyles }
`;

export default translate(StyledSelectArrayInput);



// WEBPACK FOOTER //
// ./src/components/input/SelectArrayInput/SelectArrayInput.js